import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import DonationAmountPicker from '../DonationAmountPicker/DonationAmountPicker.vue'
import SupportSelector from '../SupportSelector/SupportSelector.vue'
import FormInputTextarea from '../FormInputTextarea/FormInputTextarea.vue'
import FormRadioGroup from '../FormRadioGroup/FormRadioGroup.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import { computed, onBeforeMount, ref } from 'vue'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'
import { useStore } from 'vuex'

const QUICKPAY_MAX_AMOUNT  = 99999999


export default {
    name: 'StafetDonationStepOne',
    components: {
        DonationAmountPicker,
        SupportSelector,
        FormInputTextarea,
        FormRadioGroup,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const donationTypeEnum = Object.freeze({
            PRIVATE: 'Privat',
            COMPANY: 'Virksomhed'
        })

        const donationType = ref(donationTypeEnum.PRIVATE)
        const donationAmount = ref(null)
        const supportSelector = ref({})
        const comment = ref('')


        const radioOptions = [
            {
                value: donationTypeEnum.PRIVATE,
                label: props.labels.yourSupportPrivateSupportRadioLabel
            },
            {
                value: donationTypeEnum.COMPANY,
                label: props.labels.yourSupportCompanySupportRadioLabel
            }
        ]

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'type')) {
                    donationType.value = getFieldValue(
                        storedFields,
                        'type'
                    )
                }

                if (getFieldValue(storedFields, 'amount')) {
                    donationAmount.value = getFieldValue(
                        storedFields,
                        'amount'
                    )
                }

                if (getFieldValue(storedFields, 'donationFor')) {
                    store.dispatch('donation/donationFor', {
                        donationFor: getFieldValue(storedFields, 'donationFor')
                    })
                }

                if (getFieldValue(storedFields, 'donationTeam')) {
                    store.dispatch('donation/donationTeam', {
                        team: getFieldValue(
                            storedFields,
                            'donationTeam'
                        ).toString()
                    })
                }

                if (getFieldValue(storedFields, 'donationParticipant')) {
                    store.dispatch('donation/donationParticipant', {
                        participant: getFieldValue(
                            storedFields,
                            'donationParticipant'
                        )
                    })
                }

                if (getFieldValue(storedFields, 'comment')) {
                    comment.value = getFieldValue(
                        storedFields,
                        'comment'
                    )
                }
            }
        })

        const updateDonationType = (value) => {
            donationType.value = value
        }

        const updateSupportSelector = (data) => {
            supportSelector.value = data
        }

        const updateComment = (value) => {
            comment.value = value
        }

        const setDonationAmount = (value) => {
            donationAmount.value = value
        }

        const isDonationAmountValid = (value) =>
            {
                return value && value >= props.donationMinimumAmount && value <= QUICKPAY_MAX_AMOUNT;
            } 

        const showDonationAmountErrorMessage = computed(() => {
            return (
                !isDonationAmountValid(donationAmount.value) && props.displayInputError
            )
        })

        const stepModel = computed(() => {
            return [
                {
                    name: 'amount',
                    value: parseInt(donationAmount.value),
                    isValid: false,
                    validator: isDonationAmountValid
                },
                {
                    name: 'donationFor',
                    value: supportSelector.value.donationFor,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'holdKode',
                    value: supportSelector.value.donationTeam,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'deltagerId',
                    value: supportSelector.value.donationParticipant,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'comment',
                    value: comment.value,
                    isValid: true,
                    validator: () => true
                },
                {
                    name: 'type',
                    value: donationType.value,
                    isValid: true,
                    validator: nonEmptyStringValidator
                }
            ]
        })

        return {
            radioOptions,
            donationType,
            donationAmount,
            donationAmounts: props.donationAmounts,
            comment,
            showDonationAmountErrorMessage,
            stepModel,
            setDonationAmount,
            updateSupportSelector,
            updateComment,
            updateDonationType
        }
    }
}
